import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  task: generateApiPath({ prefix: AuthLevel.AUTH, name: 'task' }),
}

export { paths }
